import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/core';
import { ApiModule } from '../../gen/api.module';
import { Configuration } from '../../gen/configuration';
import { getApiBasePath } from './api-base-path';
const ɵ0 = getApiBasePath;
export class RealApiModule extends ApiModule {
    static forRoot(configurationFactory) {
        return {
            ngModule: RealApiModule,
            providers: [{ provide: Configuration, useFactory: configurationFactory }]
        };
    }
    constructor(parentModule, http) {
        super(parentModule, http);
    }
}
export { ɵ0 };
